<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previousProperty()" *ngIf="showPrevBtn">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{'property.propertyDetails' | translate}}</span>
    <span class="navigateBtn navigate-right" (click)="nextProperty()" *ngIf="showNextBtn">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>
  <div class="generatedHTMLRoot">
    <div class="mainSection">
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'property.addressAndLocation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.street1' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Street1" kendoTextBox id="form-Street1" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.streetNo1' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="StreetNo1" kendoTextBox id="form-StreetNo1" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.houseNoTo' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="houseNoTo" kendoTextBox id="form-houseNoTo" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.houseNoAd' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="houseNoAd" kendoTextBox id="form-houseNoAd" />
                </div>
              </div>
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.street2' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Street2" kendoTextBox id="form-Street2" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.streetNo2' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="StreetNo2" kendoTextBox id="form-StreetNo2" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.houseNo2To' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="houseNo2To" kendoTextBox id="form-houseNo2To" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.houseNo2Ad' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="houseNo2Ad" kendoTextBox id="form-houseNo2Ad" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.postalCodeManual' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PostalCodeManual" kendoTextBox id="form-PostalCodeManual" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.municipalManual' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="MunicipalManual" kendoTextBox id="form-MunicipalManual" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.province' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="RegionManual" kendoTextBox id="form-RegionManual" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.subLocation' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="subLocation"
                                      [data]="reflistData.ref_lease_transaction_sublocation"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-subLocation">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.countryID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="CountryID"
                                      [data]="reflistData.ref_valuation_country"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-CountryID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.latitude' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="Latitude" format="n5" [spinners]="false" id="form-Latitude" [min]="-90" [max]="90"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.longitude' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="Longitude" format="n5" [spinners]="false" id="form-Longitude" [min]="-180" [max]="180"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.coordinatesQuality' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="coordinatesQuality"
                                      [data]="reflistData.ref_statuskoordinate"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-coordinatesQuality">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'property.propertyInformation' | translate | uppercase }}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.propertyType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PropertyTypeCode"
                                      [data]="reflistData.ref_property_type_l3"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="propertyTypeChanged()"
                                      id="form-PropertyTypeCode">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width66percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.propertySubType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PropertySubTypeCode"
                                      [data]="reflistData.ref_property_subtype_l3_filtered"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-PropertySubTypeCode">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.buildingName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="buildingName" kendoTextBox id="form-buildingName" />
                </div>
              </div>
              <div class="field width33percent">
                &nbsp;
              </div>
              <div class="field width33percent">
                &nbsp;
              </div>

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.buildingYear' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="buildingYear" [format]="integerFormat" [spinners]="false" id="form-buildingYear" [min]="0"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.renovationYear' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="renovationYear" [format]="integerFormat" [spinners]="false" id="form-renovationYear" [min]="0"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.marketValue' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="MarketValue" format="n2" [spinners]="false" id="form-MarketValue" [min]="0"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.energyPerformanceLabel' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="energyPerformanceLabel"
                                      [data]="reflistData.ref_lease_transaction_building_energy"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-energyPerformanceLabel">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.energyCertificate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="energyCertificate"
                                      [data]="reflistData.ref_l2_energycertificate"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-energyCertificate">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>

              <div class="field width66percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.tenure' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="tenureId"
                                      [data]="reflistData.ref_l2_tenure"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-tenureId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'property.linkedData' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field" style="width: 66%">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.projectStdID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ProjectStdID"
                                      #projectRetriever
                                      [data]="retrieverData.Project"
                                      textField="projectName"
                                      [filterable]="true"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="applyProjectName()"
                                      id="form-ProjectStdID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.portfolioName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PortfolioName" kendoTextBox id="form-PortfolioName" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.linkToProjectFolder' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="linkToProjectFolder" kendoTextBox id="form-linkToProjectFolder" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.importName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="importName" kendoTextBox id="form-importName" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'property.systemInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.oid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="Oid" [format]="integerFormat" [spinners]="false" id="form-Oid"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width66percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.noJll' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="NoJll" kendoTextBox id="form-NoJll" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.propertyIdJllHistoric' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="propertyIdJllHistoric" kendoTextBox id="form-propertyIdJllHistoric" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.propertyHorizonId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="propertyHorizonId" kendoTextBox id="form-propertyHorizonId" />
                </div>
              </div>

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.propertyMDMId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="propertyMDMId" kendoTextBox id="form-propertyMDMId" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.opportunityPropertyId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="opportunityPropertyId" kendoTextBox id="form-opportunityPropertyId" />
                </div>
              </div>
              <div class="field width66percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.noNl' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="NoNl" kendoTextBox id="form-NoNl" />
                </div>
              </div>
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.communityId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="communityId" kendoTextBox id="form-communityId" />
                </div>
              </div>
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.propertyDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="propertyDescription" kendoTextBox id="form-propertyDescription" />
                </div>
              </div>
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.comment' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="comment" kendoTextBox id="form-comment" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.ownerUserID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerUserID"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-OwnerUserID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.createdDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="CreatedDate" id="form-CreatedDate" [format]="dateTimeFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.modifiedByUserId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedByUserId"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-ModifiedByUserId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'property.modifiedDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ModifiedDate" id="form-ModifiedDate" [format]="dateTimeFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
